import LazyBackgroundImage from './lazyLoadBackgroundImage'
import LazyImage from './lazyLoadImage'
import LazyFrame from './lazyLoadFrame'
import LazyComponent from './lazyLoadComponent'

export { default } from './useIsInViewport'
export { LazyBackgroundImage, LazyImage, LazyFrame, LazyComponent }
